module.exports = __webpack_public_path__ + "img/Green.63ed7462.png";